export class ConversationImportStatus {
    success: boolean;
    error: string;
    conversationId: number;
    fileName: string;
}